import { render, staticRenderFns } from "./BuyerTrafficSourcesDetails.vue?vue&type=template&id=8ef7f86e&scoped=true"
import script from "./BuyerTrafficSourcesDetails.vue?vue&type=script&lang=js"
export * from "./BuyerTrafficSourcesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef7f86e",
  null
  
)

export default component.exports